<div class="p-grid">
  <div class="p-col p-xl-10">
    <form (ngSubmit)="saveLoad()" [formGroup]="inboundLoadForm">
      <h1>{{ existingLoadId ? 'Edit' : 'Create' }} Inbound Load</h1>

      <p *ngIf="inboundLoadForm.disabled">
        <p-message closable="false" severity="warn"
                  text="The load is not editable because the unload shift is closed."></p-message>
      </p>

      <p-card header="Load Information">
        <div class="p-grid">
          <div class="form-group p-col-12 p-sm-6 p-lg-5 p-xl-4">
            <label>Load Status</label>
            <p-selectButton [options]="loadTypeOptions | async" formControlName="inboundLoadStatus"></p-selectButton>
          </div>
          <div class="form-group p-col p-lg-5 p-xl-4">
            <label class="required" for="siteSubinventoryId">Operation</label>
            <p-dropdown
              [editable]="false"
              [options]="siteSubinventories"
              formControlName="siteSubinventoryId"
              inputId="siteSubinventoryId"
              placeholder="-- Select Operation --">
            </p-dropdown>
            <error-block
              [field]="inboundLoadForm.controls.siteSubinventoryId"
              [messages]="{
              required: 'Operation is required.'
            }">
            </error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6 p-md-5 p-xl-4" *ngIf="hasArrived | async">
            <label class="required" for="arrivedDate">Date/Time Arrived</label>
            <div class="p-inputgroup">
              <p-calendar
                [showIcon]="true"
                class="form-control"
                formControlName="arrivedDate" id="arrivedDate"
                inputId="receivedDate"
                name="arrivedDate">
              </p-calendar>
              <time-entry
                formControlName="arrivedTime"
                [timezone]="siteTimezone"
                [displaySeconds]="false">
              </time-entry>
            </div>
            <error-block
              [field]="inboundLoadForm.controls.arrivedDate"
              [messages]="{
                required: 'Date Arrived is required.'
              }">
            </error-block>
            <error-block
              [field]="inboundLoadForm.controls.arrivedTime"
              [messages]="{
                required: 'Time Arrived is required.'
              }"></error-block>
          </div>
        </div>

        <div class="p-grid">
          <div class="form-group p-col-6 p-lg-5 p-xl-4">
            <label class="required" for="carrier">Carrier</label>
            <div class="p-inputgroup">
              <p-dropdown [editable]="false" [filter]="true" [options]="carrierSelects | async"
                          [resetFilterOnHide]="true" formControlName="carrierId"
                          inputId="carrier" placeholder="-- Select Carrier --"></p-dropdown>
              <button (click)="showAddCarrierDialog()" [disabled]="inboundLoadForm.disabled" icon="pi pi-plus"
                      label="Add"
                      pButton type="button"></button>
            </div>
            <app-add-carrier-form
              (update)="onCarrierCreated($event)"
              [(displayDialogFromForm)]="displayDialog"
              [carriers]="carriers | async">
            </app-add-carrier-form>
            <error-block
              [field]="inboundLoadForm.controls.carrierId"
              [messages]="{
                required: 'Carrier is required.'
              }">
            </error-block>
          </div>
          <div *ngIf="showCarrierName" class="form-group p-col-6 p-lg-5 p-xl-4">
            <label for="carrierName" class="required">Carrier Name</label>
            <input formControlName="carrierName" id="carrierName" pInputText type="text"/>
            <error-block
              [field]="inboundLoadForm.controls.carrierName"
              [messages]="{
                requiredIfNosc: 'Carrier Name is required if the Carrier is &ldquo;No SCAC&rdquo; or &ldquo;CUPU&rdquo;.'
              }">
            </error-block>
          </div>

          <div class="form-group p-col-6 p-lg-5 p-xl-4">
            <label class="required" for="trailerId">Trailer</label>
            <app-trailer-select
              inputId="trailerId"
              name="trailerId"
              formControlName="trailerId"
              [eligibleFor]="trailerEligibleFor | async"
              [siteSubinventoryId]="selectedSubinventoryId | async"
              [carrier]="selectedCarrier | async">
            </app-trailer-select>
            <error-block [field]="inboundLoadForm.controls.trailerId" [messages]="{
              required: 'Trailer is required.'
            }">
            </error-block>
          </div>
        </div>

        <div class="p-grid">
          <div class="form-group p-col">
            <label class="required" for="customer">Invoice To</label>
            <p-dropdown [editable]="false" [filter]="true"
                        [options]="customersSelects | async"
                        [resetFilterOnHide]="true"
                        formControlName="customerId" inputId="customer"
                        placeholder="-- Select Customer --"></p-dropdown>
            <error-block [field]="inboundLoadForm.controls.customerId" [messages]="{
                required: 'Customer is required.'
              }"></error-block>
          </div>
          <div class="form-group p-col">
            <label class="required" for="Pooler">Pooler</label>
            <p-dropdown [editable]="false" [filter]="true" [options]="poolersSelects | async" [resetFilterOnHide]="true"
                        formControlName="poolerId"
                        inputId="Pooler" placeholder="-- Select Pooler --"></p-dropdown>
            <error-block [field]="inboundLoadForm.controls.poolerId" [messages]="{
              required: 'Pooler is required.'
            }"></error-block>
          </div>
          <div class="form-group p-col">
            <label class="required" for="shipFromLocation">Ship From Location</label>
            <div class="p-inputgroup">
              <p-dropdown
                #poolerSelect
                (keyup.shift.tab)="hideDropdown($event)"
                (onChange)="shipToLocationSelected()"
                (onFocus)="showDropdown($event)"
                [editable]="false"
                [filter]="true"
                [options]="poolerSitesSelects | async"
                [resetFilterOnHide]="true"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                appendTo="body"
                formControlName="shipFromLocation"
                inputId="shipFromLocation"
                placeholder="-- Select Ship From Location --">
                <ng-template let-i let-item pTemplate="item">
                  <div [ngClass]="item.styleClass">{{ item.label }}</div>
                </ng-template>
              </p-dropdown>
              <button pButton type="button"
                (click)="showAddPoolerSiteDialog()"
                [disabled]="inboundLoadForm.disabled"
                [label]="inboundLoadForm.controls.shipFromLocation.value ? null : 'Add Ship From'"
                [icon]="inboundLoadForm.controls.shipFromLocation.value ? 'pi pi-pencil' : 'pi pi-plus'">
              </button>
            </div>
            <label class="address-subtext">{{ getShipToAddress() }}</label>
            <error-block [field]="inboundLoadForm.controls.shipFromLocation" [messages]="{
              required: 'Ship From Location is required.'
            }"></error-block>
          </div>
          <app-add-shipped-to-form
            (update)="onPoolerSiteChanged($event)"
            [(showDialog)]="displayAddShippedFromDialog"
            [customer]="selectedPooler | async"
            [makeGlidRequired]="sfGlidRequired"
            [poolerName]="poolerName | async"
            [siteId]="(context | async)?.site?.id"
            [updateOf]="currentShipTo | async">
          </app-add-shipped-to-form>

        </div>
        <div class="p-grid">
          <div class="form-group p-col-6 p-lg-3 p-xl-3">
            <label for="stockTransfer">Stock Transfer</label>
            <p-checkbox [binary]="true" [readonly]="true" formControlName="stockTransfer" id="stockTransfer"
                        inputId="stockTransfer"
                        name="stockTransfer"
                        value="stockTransfer"></p-checkbox>
          </div>
        </div>
      </p-card>

      <p-card header="Load Information">
        <div class="p-grid">
          <div class="form-group p-col-6 p-lg-5 p-xl-4">
            <label [class.required]="supplierBOLRequired" for="supplierBOLNum">Supplier BOL Number</label>
            <div class="p-inputgroup">
              <input formControlName="vendorBolNumber" id="vendorBolNumber" pInputText type="text"/>
              <button (click)="getBolNumber()" [disabled]="requestingBolNumber"
                      [icon]="requestingBolNumber ? 'pi pi-spin pi-spinner' : ''" id="genbol" label="Generate"
                      pButton type="button"></button>
            </div>
            <error-block
              [field]="inboundLoadForm.controls.vendorBolNumber"
              [messages]="{
                required: 'Supplier BOL Number is required.',
                numberInUse: 'Reference # is already in use.'
              }">
            </error-block>
          </div>

          <div *ngIf="hasUnloaded | async" class="form-group p-col-6 p-lg-5 p-xl-4">
            <label class="required">Shift Unloaded</label>
            <app-worked-shift-selector
              [disabled]="inboundLoadForm.disabled"
              formControlName="unloadedShiftId"
              (dateSelected)="onUnloadedShiftDateChanged($event)">
            </app-worked-shift-selector>
            <error-block
              [field]="inboundLoadForm.controls.unloadedShiftId"
              [messages]="{
                required: 'Unloaded Shift is required.'
              }">
            </error-block>
          </div>

          <div *ngIf="hasUnloaded | async" class="form-group p-col-6 p-lg-5 p-xl-4">
            <label class="required" for="unloadedTime">Date/Time Unloaded</label>
            <div class="p-inputgroup">
              <p-calendar formControlName="unloadedDate" inputId="unloadedDate" name="unloadedDate"></p-calendar>
              <time-entry formControlName="unloadedTime" inputId="unloadedTime" [displaySeconds]="false" [timezone]="siteTimezone"></time-entry>
            </div>
            <error-block
              [field]="inboundLoadForm.controls.unloadedTime"
              [messages]="{
                required: 'Time Unloaded is required.'
              }"></error-block>
            <error-block
              [field]="inboundLoadForm"
              [messages]="{
                timeSequence: 'Unload Time must be after Check-in Time.'
              }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div *ngIf="showPoNumber" class="form-group p-col p-lg-5 p-xl-3">
            <label [ngClass]="{'required':isPoNumberRequired}" for="propakPoNumber">Propak PO Number</label>
            <input formControlName="propakPoNumber" id="propakPoNumber" pInputText type="text"/>
            <error-block
              [field]="inboundLoadForm.controls.propakPoNumber"
              [messages]="{
                required: 'Propak PO Number is required for the selected operation type when unloading.'
              }">
            </error-block>
          </div>
        </div>
      </p-card>

      <p-card *ngIf="isProcessed | async" header="Load Contents">
        <div class="p-grid" *ngIf="showFullWorkflow | async">
          <div class="form-group p-col-6 p-lg-5 p-xl-4">
            <label class="required">Shift Processed</label>
            <app-worked-shift-selector
              [disabled]="inboundLoadForm.disabled"
              formControlName="processedShiftId">
            </app-worked-shift-selector>
            <error-block
              [field]="inboundLoadForm.controls.processedShiftId"
              [messages]="{
                required: 'Processed Shift is required.'
              }">
            </error-block>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-xl-10">
            <p-table [paginator]="true" [rows]="10" [value]="inboundLoadLineItems" dataKey="id" editMode="row">
              <ng-template pTemplate="header">
                <tr>
                  <th>Product</th>
                  <th class="quantityTh">Quantity</th>
                  <th>Product Description</th>
                  <th class="deleteTh">Delete</th>
                </tr>
              </ng-template>
              <ng-template let-ri="rowIndex" let-rowData pTemplate="body">
                <tr>
                  <td>
                    <p-dropdown #product (onChange)="onChangeInboundLoadField(rowData)"
                                (onHide)="product.focus()" [(ngModel)]="rowData.productId"
                                [disabled]="inboundLoadForm.disabled" [editable]="false"
                                [filter]="true" [ngModelOptions]="{standalone: true}"
                                [options]="createLineItemProductSelects(rowData) | async" [resetFilterOnHide]="true"

                                appendTo="body" name="product">
                    </p-dropdown>
                  </td>
                  <td>
                    <input #quantity (blur)="onChangeInboundLoadField(rowData)" [(ngModel)]="rowData.quantity"
                          [disabled]="inboundLoadForm.disabled"
                          [ngModelOptions]="{standalone: true}"
                          lib-numeric name="quantity" pInputText required
                          type="text">
                  </td>
                  <td>
                    <input #palletDescription="ngModel" (blur)="onChangeInboundLoadField(rowData)"
                          [(ngModel)]="rowData.palletDescription"
                          [disabled]="!rowData.isUnauthorized"
                          [ngModelOptions]="{standalone: true}" name="palletDescription"
                          pInputText
                          type="text">
                  </td>
                  <td>
                    <confirmation-button (actionConfirmed)="onInboundLoadRowCancel(rowData)"
                                        [disabled]="inboundLoadForm.disabled" [iconsOnly]="true"
                                        actionIcon="pi pi-times" actionText="Delete" cancelIcon="pi pi-minus-circle"
                                        cancelText="Cancel" confirmIcon="pi pi-times"
                                        confirmText="Delete">
                    </confirmation-button>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="5" class="centered">
                    No data available
                  </td>
                </tr>
              </ng-template>
              <ng-template let-rowData pTemplate="footer">
                <tr [formGroup]="inboundLoadLineForm">
                  <td>
                    <p-dropdown #productSelect (onChange)="onNewLineProductChange($event);" (onHide)="productSelect.focus()"
                                [editable]="false" [filter]="true" [options]="productSelects | async"
                                [readonly]="!(productSelects | async)?.length"
                                [resetFilterOnHide]="true" appendTo="body"
                                class="form-control" formControlName="productId" inputId="productID"
                                name="product" placeholder="-- Select Product --">
                    </p-dropdown>
                    <error-block [field]="inboundLoadLineForm.get('productId')" [messages]="{
                      required: 'Product is required.'
                    }">
                    </error-block>
                  </td>
                  <td>
                    <input #quantityField class="form-control" formControlName="quantity" id="quantity" lib-numeric
                          name="quantity" pInputText
                          required type="text"/>
                    <error-block [field]="inboundLoadLineForm.get('quantity')" [messages]="{
                      required: 'Quantity is required.'
                    }">
                    </error-block>
                  </td>
                  <td>
                    <input class="form-control" formControlName="palletDescription" id="palletDescription"
                          name="palletDescription" pInputText
                          type="text"/>
                    <error-block [field]="inboundLoadLineForm.get('palletDescription')" [messages]="{
                      required: 'Description is required.'
                    }">
                    </error-block>
                  </td>

                  <td>
                    <button (click)="saveILLI();" [disabled]="inboundLoadForm.disabled"
                            [ngClass]="{ 'p-state-disabled': !inboundLoadLineForm.valid }" icon="pi pi-plus" iconPos="left"
                            label="Add"
                            pButton
                            type="button"></button>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="centered">
                    <data [value]="totalQuantity" class="total-quantity" aria-label="Total Quantity">Total Quantity: {{totalQuantity.toLocaleString()}}</data>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <error-block [field]="inboundLoadForm" [messages]="{
              lineItemsExist: 'Load must have one or more line items.'
            }"></error-block>
        </div>
      </p-card>

      <p-card *ngIf="hasUnloaded | async" header="Exceptions">
        <div class="p-grid">
          <div class="form-group p-col-3 p-md-2 p-xl-1">
            <label for="isRejected">Site Rejected</label>
            <p-checkbox [binary]="true" formControlName="isRejected" inputId="isRejected"
                        name="isRejected">
            </p-checkbox>
          </div>
          <div class="form-group p-col-9 p-md-8 p-xl-5" *ngIf="inboundLoadForm.controls.isRejected.value">
            <label for="rejectedBolNumber">Rejected BOL Number</label>
            <input formControlName="rejectedBolNumber" id="rejectedBolNumber" name="rejectedBolNumber" pInputText
                    type="text"/>
          </div>
        </div>
        <div class="p-grid">
          <div *ngIf="inboundLoadForm.controls.isRejected.value" class="p-col-12">
            <p-message severity="warn" text="Only use this if load is from your site."></p-message>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-3 p-md-2 p-xl-1">
            <label for="redTagFlag">Red Tag</label>
            <p-checkbox [binary]="true" formControlName="redTagFlag" inputId="redTagFlag"
                        name="redTagFlag">
            </p-checkbox>
          </div>
          <div class="form-group p-col-9 p-md-8 p-xl-5" *ngIf="inboundLoadForm.controls.redTagFlag.value">
            <label for="redTagReason">Reason</label>
            <input formControlName="redTagReason" id="redTagReason" name="redTagReason" pInputText
                    type="text"/>
          </div>
        </div>
      </p-card>
      <p-card>
        <div class="p-grid">
          <div class="form group p-col-6">
            <label for="comments">Comments</label>
            <div>
              <textarea class="form-control" formControlName="comments" id="comments" maxlength="255"
                        pInputTextarea>
              </textarea>
            </div>
          </div>
          <div class="form group p-col-12 p-lg-6">
            <div>
              <blob-storage
                [label]="'Inbound Documents'"
                [fileTypes]="['Inbound Load']"
                [entityId]="existingLoadId"
                [entityParent]="'InboundLoads'"
                [documentIds]="documents"
                [siteId]="(context | async)?.site?.id">
              </blob-storage>
            </div>
          </div>
        </div>
      </p-card>
      <p-card>
        <div class="form-buttons">
          <button (click)="resetInboundLoadAutoSave()"
                  *ngIf="existingLoadId ? false : true"
                  [disabled]="inboundLoadForm.disabled"
                  class="p-button-info"
                  icon="pi pi-times-circle"
                  label="Reset Autosave"
                  pButton
                  type="button">
          </button>
          <button [disabled]="inboundLoadForm.disabled || saving"
                  [icon]="saving ? 'pi pi-spin pi-spinner' : (existingLoadId ? 'pi pi-check' : 'pi pi-plus')"
                  [label]="(existingLoadId ? 'Update' : 'Create') + ' Load'"
                  [ngClass]="{'p-button-success ml' : true, 'p-state-disabled ml' : (inboundLoadForm.statusChanges | async) !== 'VALID'}"
                  pButton
                  type="submit">
          </button>
        </div>
      </p-card>
    </form>
  </div>
</div>
